import {ContactUsForm, FormValues} from "@bounce/shared/consumer/components";
import {InteractionType} from "@bounce/shared/enums";
import NiceModal, {NiceModalHocProps} from "@ebay/nice-modal-react";
import React, {useEffect} from "react";
import {useForm} from "react-hook-form";
import {toast} from "sonner";
import {useAddEvent, useGetContactDetailQuery} from "~/api/requests";
import {Pages} from "~/bi-events/enum";
import {useAuth} from "@bounce/shared/contexts";
import {useAmplitude} from "~/contexts";
import {useAccountId} from "~/hooks";

interface ContactUsDialogProps extends NiceModalHocProps {
  fetchContact: boolean;
}

const ContactUsDialog = NiceModal.create(({fetchContact = true}: ContactUsDialogProps) => {
  const {pageViewEvent, pageClickEvent} = useAmplitude();
  const {userId} = useAuth();
  const accountId = useAccountId();

  const addEventState = useAddEvent();
  const contactDetail = useGetContactDetailQuery({}, {enabled: fetchContact});

  const {control, handleSubmit, formState, reset, setValue} = useForm<FormValues>();
  const {isValid} = formState;

  useEffect(() => {
    if (contactDetail?.data) {
      setValue("email", contactDetail.data.email);
    }
  }, [contactDetail?.data?.email]);

  const onSubmit = handleSubmit(async (data): Promise<void> => {
    try {
      const result = await addEventState.mutateAsync({
        eventData: {
          type: InteractionType.CONTACT_US,
          user_id: userId,
          account_id: accountId || undefined,
          data: {email: data.email, text: data.message},
        },
      });
      if (result) {
        toast.success("Message sent successfully");
        reset();
      }
    } catch (e) {
    } finally {
      pageClickEvent({page: Pages.GET_HELP, cta: "send", data: {text: data.message}});
    }
  });

  useEffect(() => {
    pageViewEvent({page: Pages.GET_HELP});
  }, []);

  return <ContactUsForm onSubmit={onSubmit} isValid={isValid} control={control} />;
});

export default ContactUsDialog;
